import React, { useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import Products from ".";
import { useMastersContext } from "../../../../contexts/masters.context";
import BootstrapModal from "../../shared/bootstrap/BootstrapModal";
//import productService from "../../../../services/productService";
import CrudTable from "../../shared/table/CrudTable";
import { TABLE_COLUMNS } from "./models/productTableColumns";
import ProductDetails from "./ProductDetails";

function ProductTable() {
  const history = useHistory();
  const [productDetails, setProductDetails] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const { productState } = useMastersContext();

  useEffect(() => {
    productState.fetch();
  }, []);

  const columns = useMemo(() => TABLE_COLUMNS, [TABLE_COLUMNS]);
  const data = useMemo(() => productState.data || [], [productState.data]);

  const showProductDetails = (id) => {
    const products = productState.data.filter(
      (p) => p.product_ID === Number(id)
    );

    const _product = products.length > 0 ? products[0] : null;

    setProductDetails(_product);
    setShowModal(true);
    console.log(showModal);
  };

  return (
    <div>
      <div className="row">
        <div className="col"></div>
        <div className="col">
          <h4>Products</h4>
        </div>
        <div className="col"></div>
        {/* <div className="col d-flex justify-content-end">
          <button
            className="btn btn-sm btn-success"
            onClick={() => history.push("/masters/additional-locations/add")}
          >
            Add New
          </button>
        </div> */}
      </div>
      <hr />
      <CrudTable
        loading={productState.loading}
        data={data}
        columns={columns}
        idField="product_ID"
        showDetails={true}
        showEdit={false}
        showRemove={false}
        onDetails={showProductDetails}
      />
      <BootstrapModal
        id="productDetailsModel"
        title="Product Details"
        visible={showModal}
        setVisible={setShowModal}
        size="modal-xl"
      >
        <ProductDetails data={productDetails} />
      </BootstrapModal>
    </div>
  );
}

export default ProductTable;
